import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbLink = ({ link, isLast }) => {
  return (
    <li
      className="breadcrumb-link"
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <a href={link.url} aria-current={isLast ? 'page' : null} itemProp="item">
        <span class="breadcrumb-link__span" itemProp="name">
          {link.name}
        </span>
      </a>
      <meta itemProp="position" content={link.position} />
    </li>
  );
};

BreadcrumbLink.propTypes = {
  position: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default BreadcrumbLink;
